import { Injectable, inject } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog } from '@angular/material/dialog';
import { AccountChangePasswordComponent } from './account-change-password/account-change-password.component';
import { AccountChangeUsernameComponent } from './account-change-username/account-change-username.component';
import { LogoutService } from './logout.service';
import { MobileNavigationService } from './mobile-navigation.service';
import { ToastService } from './toast/toast.service';

@Injectable({ providedIn: 'root' })
export class AccountActionsService {
  private readonly dialog = inject(MatDialog);
  private readonly logoutService = inject(LogoutService);
  private readonly mobileNavigation = inject(MobileNavigationService);
  private readonly toastService = inject(ToastService);

  openChangePassword(): void {
    this.openAccountDialog(
      AccountChangePasswordComponent,
      'account-change-password-title',
      'account-change-password-description'
    );
  }

  openChangeUsername(): void {
    this.openAccountDialog(
      AccountChangeUsernameComponent,
      'account-change-username-title',
      'account-change-username-description'
    );
  }

  logout(): void {
    this.mobileNavigation.close();
    this.logoutService.logout().subscribe({
      error: () => this.toastService.showError('account.logout.failed')
    });
  }

  private openAccountDialog(component: ComponentType<unknown>, ariaLabelledBy: string, ariaDescribedBy: string): void {
    this.mobileNavigation.close();
    this.dialog.open(component, {
      panelClass: 'account-dialog-panel',
      backdropClass: 'account-dialog-backdrop',
      width: 'min(calc(100vw - 2rem), 28rem)',
      maxWidth: 'calc(100vw - 2rem)',
      autoFocus: 'input',
      restoreFocus: true,
      ariaLabelledBy,
      ariaDescribedBy
    });
  }
}
